import React from "react";
import {
  Grid,
  Stack,
  Typography,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
//icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import EmptyImge from "../../Assets/empty-image.png";
import "../../Style/dialogstyle.scss";

export default function ViewClassItem({ open, handleClose, editData }) {
  // console.log("editData::", editData);

  return (
    <div>
      <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
        <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">
                ពិនិត្យសម្ភារៈក្នុងថ្នាក់
              </Typography>
            </Stack>
            <Stack direction="column" justifyContent="center">
              <IconButton onClick={handleClose}>
                <BiMinusCircle className="close-icon" />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5}>
                <Typography className="field-title">ថ្នាក់រៀន</Typography>
                <Typography className="field-title">៖</Typography>
                <Typography className="field-title">
                  {editData?.gradeId?.gradeName}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Box sx={{ padding: "10px" }}>
            <Stack
              direction="column"
              spacing={2}
              sx={{ width: "100%" }}
              className="view-dialog-contanier"
            >
              <Stack direction="row" spacing={1} className="view-header">
                <Typography
                  className="field-title-list"
                  sx={{ width: "10%" }}
                  align="center"
                >
                  រូបភាព
                </Typography>
                <Typography className="field-title-list" sx={{ width: "65%" }}>
                  ឈ្មោះសម្ភារៈ
                </Typography> 
                <Typography className="field-title-list" sx={{ width: "10%" }}>
                  ចំនួន
                </Typography>
                <Typography className="field-title-list" sx={{ width: "15%" }}>
                  ឯកតា
                </Typography>
              </Stack>

              {editData?.items?.map((row, index) => {
                return (
                  <Stack direction="row" spacing={1} key={index}>
                    <Stack
                      width="10%"
                      direction={`row`}
                      justifyContent="center"
                    >
                      <img
                        src={
                          row?.listMaterialUnitId?.imageSrc
                            ? row?.listMaterialUnitId?.imageSrc
                            : EmptyImge
                        }
                        alt=""
                        style={{
                          borderRadius: "5px",
                          objectFit: "cover",
                          width: "80%",
                        }}
                      />
                    </Stack>
                    <Stack
                      paddingLeft={`6px`}
                      width="65%"
                      direction="column"
                      justifyContent="center"
                    >
                      <Typography className="field-title" width="100%">
                        {"ISBN: "+ row?.listMaterialUnitId?.materialId?.isbm + " - "+row?.listMaterialUnitId?.materialId?.materialKhName}
                      </Typography>
                    </Stack>

                    <Stack
                      width="10%"
                      direction="column"
                      justifyContent="center"
                    >
                      <Typography className="field-title" width="100%">
                        {row?.qty}
                      </Typography>
                    </Stack>
                    
                    <Stack
                      width="15%"
                      direction="column"
                      justifyContent="center"
                    >
                      <Typography className="field-title" width="100%">
                        {row?.listMaterialUnitId?.unitId?.unitKhName}
                      </Typography>
                    </Stack>
                    
                  </Stack>
                );
              })}
            </Stack>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
